import Login from "./Login/Login";
import NavBar from "./NavBar/NavBar";
import FrontPage from "./pages/FrontPage/FrontPage";
import Form from "./Form/Form";
const components = { FrontPage, Login, NavBar, Form };

export default components;
